// extracted by mini-css-extract-plugin
export default {"emptyList":"EmptyPageList_emptyList__Cos2P","iconWrapper":"EmptyPageList_iconWrapper__kkvqc","title":"EmptyPageList_title__FGkke","lead":"EmptyPageList_lead__AKEtc"};